"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCBase_1 = __importDefault(require("./VoxeetRTCBase"));
const path_1 = __importDefault(require("path"));
class VoxeetRTCNode extends VoxeetRTCBase_1.default {
    constructor() {
        super();
        this.engine = null;
        this.ownerId = null;
        this.peers = [];
        this.isMuted = false;
        this.mutedPeer = [];
        this.speechThreshold = 0.05;
        this.ssMsid = 'none';
    }
    enumerateAudioDevices(type) {
        if (type === 'input') {
            return Promise.resolve(this.engine.enumerateAudioDevices());
        }
        else {
            return Promise.resolve(this.engine.enumerateAudioOutputDevices());
        }
    }
    static enumerateAudioDevices(type) {
        return Promise.resolve([]);
    }
    static enumerateVideoDevices() {
        return Promise.resolve(MediaEngine.enumerateVideoDevices());
    }
    init({ constraints, processCb, listenOnly, ownerId, mixing }) {
        return new Promise((resolve, reject) => {
            try {
                this.ownerId = ownerId;
                if (mixing.uri.search('rtmp://') === -1) {
                    mixing.uri = path_1.default.join('out/', mixing.uri);
                }
                this.engine = new MediaEngine();
                if (mixing.enabled) {
                    this.engine.initMixer(mixing.uri);
                }
                else {
                    this.engine.init();
                }
                this.engine.on('sessionCreated', this.onSessionCreated.bind(this));
                this.engine.on('sessionError', this.onSessionError.bind(this));
                this.engine.on('streamAdded', this.onStreamAdded.bind(this));
                this.engine.on('streamUpdated', this.onStreamUpdated.bind(this));
                this.engine.on('streamRemoved', this.onStreamRemoved.bind(this));
                this.engine.on('screenStreamAdded', this.onScreenStreamAdded.bind(this));
                this.engine.on('screenStreamRemoved', this.onScreenStreamRemoved.bind(this));
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    release() {
        if (this.engine) {
            this.engine.release();
            this.engine = null;
        }
    }
    onSessionCreated(peerId, type, sdp) {
        console.log('--- session created', peerId, type);
        super.sessionCreatedEvent(peerId, { type: type, sdp: sdp }, null, this.ssMsid, 'default');
    }
    onSessionError(peerId, error) {
        console.log('--- session error', peerId, error);
    }
    onStreamAdded(peerId, stream) {
        console.log('--- stream added', peerId, stream);
        this.addStreamEvent(peerId, stream);
    }
    onStreamUpdated(peerId, stream) {
        console.log('--- stream updated, peerId, stream');
        this.updateStreamEvent(peerId, stream);
    }
    onStreamRemoved(peerId, stream) {
        console.log('--- stream removed', peerId);
        this.removeStreamEvent(peerId);
    }
    onScreenStreamAdded(peerId, stream) {
        console.log('--- screen stream added', peerId);
        this.ssMsid = stream.label();
        this.addScreenStreamEvent(peerId, stream);
    }
    onScreenStreamRemoved(peerId, stream) {
        console.log('--- screen stream removed', peerId);
        this.ssMsid = 'none';
        this.removeScreenStreamEvent();
    }
    attachMediaStream(renderer, peerId, stream) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.attachMediaStream(renderer, peerId, stream);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    createPeerConnection(peerId, state, isMaster) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.createPeerConnection(peerId, isMaster);
                resolve({ peer: {}, isNew: false });
            }
            catch (e) {
                reject(e);
            }
        });
    }
    closePeerConnection(peerId) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.closePeerConnection(peerId);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    removePeerConnection(peerId) { }
    setRemoteDescription(peerId, ssrc, type, sdp, cb) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.setRemoteDescription(peerId, ssrc, type, sdp);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    setPeerCandidate(peerId, sdpMid, sdpMLineIndex, sdp) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.setPeerCandidate(peerId, sdpMid, sdpMLineIndex, sdp);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    createAnswer(peerId) {
        return new Promise((resolve, reject) => {
            try {
                const answer = this.engine.createAnswer(peerId);
                this.engine.setLocalDescription(peerId, 'answer', answer);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    startVideoForPeer(peerId, constraints) {
        // Only for master
        return new Promise((resolve, reject) => {
            try {
                console.log(constraints);
                this.engine.startVideo();
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    stopVideoForPeer(peerId) {
        // Only for master
        return new Promise((resolve, reject) => {
            try {
                this.engine.stopVideo();
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    selectAudioInput(deviceId) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.selectAudioDevice(deviceId);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    selectAudioOutput(deviceId) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.selectAudioOutputDevice(deviceId);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    selectVideoInput(deviceId) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.selectVideoDevice(deviceId);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    getLevel(peerId, callback) {
        try {
            const level = parseFloat(this.engine.getLevel(peerId));
            callback(level);
        }
        catch (e) {
            console.error(e);
        }
    }
    isSpeaking(peerId, callback) {
        this.getLevel(peerId, (level) => {
            if (level > this.speechThreshold) {
                callback(true);
            }
            else {
                callback(false);
            }
        });
    }
    setPeerPosition(peerId, posX, posY) {
        return new Promise((resolve, reject) => {
            try {
                //const angle = (90 - Math.atan2(posY, posX) * 180.0 / Math.PI) / 90.0;
                //const angle = (Math.atan(posY/posX)*180.0/Math.PI)/90.0;
                let angle = 90.0 - (Math.atan2(posY, posX) * 180.0) / Math.PI;
                const distance = Math.sqrt(Math.pow(posX, 2) + Math.pow(posY, 2));
                angle = angle / 90.0;
                console.log(peerId, posX, posY, distance, angle);
                if (distance !== NaN && angle !== NaN) {
                    this.engine.setPeerPosition(peerId, angle, distance);
                }
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
    getPeerPosition() {
        return { x: 0, y: 0 };
    }
    toggleMute(peerId) {
        let muted = false;
        try {
            if (peerId == this.ownerId) {
                // Master
                this.isMuted = !this.isMuted;
                muted = this.isMuted;
                this.engine.setMute(this.isMuted);
            }
            else {
                const found = this.mutedPeer.find((id) => id === peerId);
                if (found) {
                    this.mutedPeer = this.mutedPeer.filter((id) => id !== peerId);
                    muted = false;
                }
                else {
                    this.mutedPeer.push(peerId);
                    muted = true;
                }
                this.engine.setParticipantMute(peerId, muted);
            }
        }
        catch (e) {
            console.error(e);
        }
        return muted;
    }
    enable3DAudio(isEnable) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.enable3DAudio(isEnable);
                resolve();
            }
            catch (e) {
                console.error(e);
                reject(e);
            }
        });
    }
    hasScreenShare() {
        return false;
    }
    startScreenShare(sourceId, cb) {
        return new Promise((resolve, reject) => {
            try {
                this.engine.startScreenshare();
                resolve();
            }
            catch (e) {
                console.error(e);
                reject();
            }
        });
    }
    stopScreenShare() {
        try {
            this.engine.stopScreenshare();
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.default = VoxeetRTCNode;
